// 异常页面

const clientRouter = {
  path: 'exception',
  name: 'exception',
  component: { render: h => h('router-view') },
  children: [
    {
      path: '/404',
      name: 'notFound',
      meta: { isBreadcrumb: true },
      component: () =>
        import(/* webpackChunkName: 'exception' */ 'views/exception/404'),
    },
  ],
}

export default clientRouter
